var map = {
	"./logo-etsy.png": [
		5911,
		911
	],
	"./logo-etsy@2x.png": [
		857,
		857
	],
	"./logo-etsy@3x.png": [
		4254,
		254
	],
	"./logo-hubspot.png": [
		8815,
		815
	],
	"./logo-hubspot@2x.png": [
		4078,
		697
	],
	"./logo-hubspot@3x.png": [
		3606,
		606
	],
	"./logo-square.png": [
		2089,
		89
	],
	"./logo-square@2x.png": [
		2347,
		347
	],
	"./logo-square@3x.png": [
		7472,
		472
	],
	"./logo-stripe.png": [
		6519,
		519
	],
	"./logo-stripe@2x.png": [
		7577,
		577
	],
	"./logo-stripe@3x.png": [
		5902,
		902
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8875;
module.exports = webpackAsyncContext;